/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { getCountryFromLanguage } from "../../../core/service/BusinessLogicService"
import { DATE_FORMAT, FOREIGN_DEPARTEMENT } from "../constants/identificationPageConstants.js"
import axios from "axios"
import CodiceFiscale from "codice-fiscale-js"
import createDecorator from "final-form-calculate"
import moment from "moment"

const fisalNumberDecorator = (tunnelData) => {
  if (getCountryFromLanguage(tunnelData?.data?.order?.orderLanguageTag) !== "IT") {
    return { field: "", updates: {} }
  }
  return {
    field: "identity.taxNumber",
    updates: {
      "identity.birthDate": (ignoredValue, allValues) => {
        try {
          let codiceFiscale = new CodiceFiscale(allValues.identity.taxNumber)
          let day =
            ("" + codiceFiscale.birthday.getUTCDate()).length === 1
              ? "0" + codiceFiscale.birthday.getUTCDate()
              : codiceFiscale.birthday.getUTCDate()
          let month = ("" + codiceFiscale.month).length === 1 ? "0" + codiceFiscale.month : codiceFiscale.month
          return moment(day + "/" + month + "/" + codiceFiscale.year, "DD/MM/YYYY").format(
            DATE_FORMAT.identity.birthDate["IT"]
          )
        } catch (error) {
          return null
        }
      },
      "identity.birthCountry": async (ignoredValue, allValues) => {
        try {
          let codiceFiscale = new CodiceFiscale(allValues.identity.taxNumber)
          if (codiceFiscale.birthplace.prov !== FOREIGN_DEPARTEMENT) {
            let response = await axios.get(
              tunnelData.apiUrl +
                "middle-business-service/api/v2/repository/country-cadastral?journeyCountryCode=IT&countryCode=IT",
              {
                headers: {
                  Authorization: `Bearer ${tunnelData.access_token}`,
                  Accept: "*/*"
                }
              }
            )
            return response.data
          } else {
            let response = await axios.get(
              tunnelData.apiUrl +
                "middle-business-service/api/v2/repository/country-cadastral/foreign-country?cadastralCode=" +
                codiceFiscale.birthplace.cc,
              {
                headers: {
                  Authorization: `Bearer ${tunnelData.access_token}`,
                  Accept: "*/*"
                }
              }
            )
            return response.data
          }
        } catch (error) {
          return null
        }
      },
      "identity.birthDepartment": async (ignoredValue, allValues) => {
        try {
          let codiceFiscale = new CodiceFiscale(allValues.identity.taxNumber)
          let response = await axios.get(
            tunnelData.apiUrl +
              "middle-business-service/api/v2/repository/department-cadastral?cadastralCode=" +
              codiceFiscale.birthplace.cc,
            {
              headers: {
                Authorization: `Bearer ${tunnelData.access_token}`,
                Accept: "*/*"
              }
            }
          )
          return response.data
        } catch (error) {
          return null
        }
      },
      "identity.birthCity": async (ignoredValue, allValues) => {
        try {
          let codiceFiscale = new CodiceFiscale(allValues.identity.taxNumber)
          if (codiceFiscale.birthplace.prov !== FOREIGN_DEPARTEMENT) {
            let response = await axios.get(
              tunnelData.apiUrl +
                "middle-business-service/api/v2/repository/city-cadastral?cadastralCode=" +
                codiceFiscale.birthplace.cc,
              {
                headers: {
                  Authorization: `Bearer ${tunnelData.access_token}`,
                  Accept: "*/*"
                }
              }
            )
            return response.data
          } else {
            let response = await axios.get(
              tunnelData.apiUrl +
                "middle-business-service/api/v2/repository/country-cadastral/foreign-country?cadastralCode=" +
                codiceFiscale.birthplace.cc,
              {
                headers: {
                  Authorization: `Bearer ${tunnelData.access_token}`,
                  Accept: "*/*"
                }
              }
            )
            return response.data.label
          }
        } catch (error) {
          return null
        }
      },
      "identity.disableFiscalCodeFields": async (ignoredValue, allValues) => {
        try {
          let codiceFiscale = new CodiceFiscale(allValues.identity.taxNumber)
          if (codiceFiscale.code === allValues.identity.taxNumber) {
            return true
          }
        } catch (error) {
          return false
        }
      }
    }
  }
}
const birthCountryDecorator = () => {
  return {
    field: "identity.birthCountry",
    updates: {
      "identity.birthDepartment": (ignoredValue, allValues) => {
        if (!allValues.identity.birthCountry) {
          return null
        } else {
          // this else is mandatory otherwise it will return '' by default
          return allValues.identity.birthDepartment
        }
      }
    }
  }
}

const birthDepartmentDecorator = () => {
  return {
    field: "identity.birthDepartment",
    updates: {
      "identity.birthCity": (ignoredValue, allValues) => {
        if (!allValues.identity.birthDepartment) {
          return null
        } else {
          // this else is mandatory otherwise it will return '' by default
          return allValues.identity.birthCity
        }
      }
    }
  }
}
export default (tunnelData) => {
  return createDecorator(fisalNumberDecorator(tunnelData), birthCountryDecorator(), birthDepartmentDecorator())
}
